module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNSIgdmlld0JveD0iMCAwIDI0IDI1IiBmaWxsPSJub25lIj4KICA8cGF0aCBkPSJNMTIuMzg1IDE2LjA0MTdMNi42MzYzNSA5Ljc5MTY3TDcuNjY2MzIgOC42NzE4OEwxMi4zODUgMTMuODAyMUwxNy4xMDM3IDguNjcxODhMMTguMTMzNyA5Ljc5MTY3TDEyLjM4NSAxNi4wNDE3WiIgZmlsbD0id2hpdGUiLz4KPC9zdmc+"


//////////////////
// WEBPACK FOOTER
// ./src/assets/arrow-down.svg
// module id = zpNP
// module chunks = 1